<script setup>
  const props = defineProps({
    color: String
  })
</script>
<template>
  <div class="my-16 sm:my-28 max-w-screen-2xl mx-auto px-5">
    <div :class="['grid', 'grid-cols-1', 'lg:grid-cols-2', 'rounded-3xl', color]">
      <slot></slot>
    </div>
  </div>
</template>